import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoadingService } from 'src/app/services/loading/loading.service';
import { UserService } from 'src/app/services/management/user/user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  constructor(private fb: FormBuilder, private loadingService: LoadingService, private userService: UserService) { }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      email: '',
      password: ''
    });
    this.loginForm.controls.email.setValidators([Validators.required]);
    this.loginForm.controls.password.setValidators([Validators.required]);
  }

  submitForm() {

    if (this.loginForm.controls.email.valid && this.loginForm.controls.password.valid) {
      this.userService.login({
        email: this.loginForm.controls.email.value,
        password: this.loginForm.controls.password.value
      });
    }
  }

}
